export { default } from './LocationSearchInput';
